import React from 'react';
import PropTypes from 'prop-types';
import { TextStyledTag } from './styles';

const Text = ({
  tag,
  light,
  noMargin,
  block,
  small,
  bold,
  style,
  children,
  withCursor,
  onClick,
  size = 'base',
  type,
  testid,
  output,
  id,
  ...rest
}) => {
  size = type === 2 ? 'small' : size;

  return (
    <TextStyledTag
      as={tag}
      data-testid={testid}
      inline={!block}
      onClick={onClick}
      light={light}
      noMargin={noMargin}
      bold={bold}
      type={small ? 'small' : size}
      style={style}
      withCursor={!!withCursor || !!onClick}
      id={output ? undefined : id}
      {...rest}
    >
      {output ? (
        <output style={style} id={id}>
          {children}
        </output>
      ) : (
        children
      )}
    </TextStyledTag>
  );
};

Text.propTypes = {
  tag: PropTypes.elementType,
  noMargin: PropTypes.bool,
  light: PropTypes.bool,
  bold: PropTypes.bool,
  block: PropTypes.bool,
  small: PropTypes.bool,
  size: PropTypes.string,
  testid: PropTypes.string,
  type: PropTypes.number,
  style: PropTypes.object,
  children: PropTypes.node,
  withCursor: PropTypes.bool,
  output: PropTypes.bool,
  id: PropTypes.string,
  onClick: PropTypes.func,
};

Text.defaultProps = {
  small: false,
  tag: 'span',
};

export default React.memo(Text);
